import { apply } from '@/server/builder';

export const method = 'get';

export default (schema, request) => {
    const customers = schema.customers.all().models;


    return apply(customers, request.queryParams);
};
